"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiasporaMovement = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var DiasporaMovement = (function (_super) {
    __extends(DiasporaMovement, _super);
    function DiasporaMovement() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.DIASPORA_MOVEMENT,
            tags: [Tags_1.Tags.JOVIAN],
            cost: 7,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.party(PartyName_1.PartyName.REDS); }),
            metadata: {
                cardNumber: 'TO4',
                description: 'Requires that Reds are ruling or that you have 2 delegates there. Gain 1M€ for each Jovian tag in play, including this.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(1).slash().jovian().played.any;
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    DiasporaMovement.prototype.play = function (player) {
        var amount = player.game.getPlayers()
            .map(function (p) { return p.getTagCount(Tags_1.Tags.JOVIAN, false, p.id === player.id ? true : false); })
            .reduce(function (a, c) { return a + c; });
        player.addResource(Resources_1.Resources.MEGACREDITS, amount + 1);
        return undefined;
    };
    DiasporaMovement.prototype.getVictoryPoints = function () {
        return 1;
    };
    return DiasporaMovement;
}(Card_1.Card));
exports.DiasporaMovement = DiasporaMovement;
//# sourceMappingURL=DiasporaMovement.js.map